import { baseAxios } from "../index";

export async function getAllListUsaha(dispatch, data, history) {
  //   console.log(data, "data list usaha");
  try {
    const response = await baseAxios.get(
      `webUsaha/getAllUsaha?page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({ type: "SET_ALL_USAHA", data: response.data });
    // console.log(response, "response list usaha");
    return response;
  } catch (err) {
    return err.response;
  }
}
